export default {"src":"/_next/static/media/rio.0b824cfb.svg","height":123,"width":283,"blurWidth":0,"blurHeight":0};